import EntityTypeEnum from 'common/enums/entityTypeEnum'
import CarouselInterface from 'common/types/entities/CarouselInterface'
import { MasterBlockId } from 'common/types/entities/EntityInterface'
import {
  generateHtmlAttrId,
  generateId,
} from 'src/shared/entities/utils/generate-base-entity'

export function createCarousel(
  parentId: string,
  masterBlockId?: MasterBlockId,
): CarouselInterface {
  return {
    id: generateId(),
    type: EntityTypeEnum.Carousel,
    childIds: [],
    parentId: parentId,
    masterBlockId: masterBlockId,
    controlsColor: 'rgba(255, 255, 255, 1)',
    arrowsColor: 'rgba(255, 255, 255, 1)',
    padding: {
      paddingTop: 10,
      paddingRight: 10,
      paddingBottom: 10,
      paddingLeft: 10,
    },
    mobilePadding: {
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingLeft: 0,
    },
    margin: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
    },
    mobileMargin: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
    },
    showArrows: true,
    appearance: {
      desktop: true,
      mobile: true,
    },
    htmlAttrId: generateHtmlAttrId(EntityTypeEnum.Carousel),
  }
}
